import { useEffect, useState } from 'react';
import { GlobalVariables } from 'config/constant';
import useDeepEffect from 'hooks/useDeepEffect';

export default function useDebounce<T>(
  value: T,
  delay?: number,
  { shouldUseDeepEffect }: { shouldUseDeepEffect?: boolean } = {},
): T {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  const useEffectHook = shouldUseDeepEffect ? useDeepEffect : useEffect;

  useEffectHook(() => {
    // Update debounced value after delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay ?? GlobalVariables.DebounceTime.Medium);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
